<template>
    <!-- 提现审核 -->
    <div class="container">
        <div class="handle-box-search">
            <el-row class="head-search">
                <el-col :span="12">
                    <span class="title">合伙人名称:</span>
                    <el-input
                        v-model="search_data.promoter_name"
                        placeholder="请输入合伙人名称 "
                        @keyup.enter.native="searchdistributionWithdrawLists"
                        style="width: 200px"
                    ></el-input>
                </el-col>
                <el-col :span="12">
                    <span class="title">合伙人电话:</span>
                    <el-input
                        v-model="search_data.promoter_phone"
                        placeholder="请输入合伙人名称 "
                        @keyup.enter.native="searchdistributionWithdrawLists"
                        style="width: 200px"
                    ></el-input>
                </el-col>
            </el-row>
            <el-row class="head-search">
                <el-col :span="12">
                    <span class="title">审核状态:</span>
                    <el-select v-model="search_data.withdraw_status" placeholder="请选择审核状态" clearable style="width: 200px">
                        <el-option v-for="(item, index) in status_select" :key="index" :label="item.alias" :value="item.val"> </el-option>
                    </el-select>
                </el-col>
            </el-row>

            <el-button type="primary" icon="el-icon-search" @click="searchdistributionWithdrawLists">搜索</el-button>

            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
  

        <!-- 表格 -->
        <div style="text-align: right; padding: 20px; border-bottom: 1px solid #ebeef5; color: #606266">
            共 {{ result_data.count }} 条数据，申请提现金额共计：{{ result_data.total }} 元
        </div>
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="promoter_name" label="合伙人姓名" min-width="50"> </el-table-column>

            <el-table-column prop="promoter_phone" label="合伙人电话" min-width="80"> </el-table-column>

            <el-table-column prop="create_time" label="申请时间" min-width="100"> </el-table-column>
            <el-table-column prop="balance_amount" label="账户余额" min-width="80"> </el-table-column>
            <el-table-column prop="withdraw_amount" label="申请金额" min-width="80"> </el-table-column>
            <el-table-column prop="withdraw_status_name" label="状态" min-width="80"> </el-table-column>

            <el-table-column label="操作" width="260">
                <template slot-scope="scope">
                    <el-button
                        :disabled="scope.row.withdraw_status_name !== '待审核'"
                        type="primary"
                        @click="executeDistributionWithdrawSubmit(scope.row, '1')"
                    >
                        通过
                    </el-button>
                    <el-button
                        :disabled="scope.row.withdraw_status_name !== '待审核'"
                        type="info"
                        @click="executeDistributionWithdrawSubmit(scope.row, '2')"
                    >
                        拒绝提现
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
    </div>
</template>

<script>
var _this;
// import bugDetermine from "./bugDetermine.vue";
import bus from '@/components/common/bus.js';

export default {
    data() {
        return {
            excute_data: {
                withdraw_code: '',
                withdraw_status: ''
            },
            status_select: [
                {
                    val: '0',
                    alias: '待审核'
                },
                {
                    val: '1',
                    alias: '成功'
                },
                {
                    val: '2',
                    alias: '拒绝'
                },

                {
                    val: '3',
                    alias: '失败'
                },

                {
                    val: '4',
                    alias: '提现中'
                }
            ],

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                promoter_name: '',
                promoter_phone: '',
                withdraw_status: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.searchdistributionWithdrawLists();
    },

    methods: {
        // 通过或拒绝提现接口
        executeDistributionWithdrawSubmit(e, val) {
            _this.excute_data.withdraw_code = e.withdraw_code;
            _this.excute_data.withdraw_status = val;

            _this
                .$post('/distribution/executeDistributionWithdrawSubmit', _this.excute_data)
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.distributionWithdrawLists();
                })
                .catch((err) => {});
        },
        // 搜索
        searchdistributionWithdrawLists() {
            _this.search_data.page = 1;
            _this.distributionWithdrawLists();
        },
        // 列表
        distributionWithdrawLists() {
            _this
                .$post('/distribution/distributionWithdrawLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data.result;
                    _this.result_data = res.data;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.distributionWithdrawLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
</style>